import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ac05df5"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["dimmed"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal-bar father" }, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "vertical-bar" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "horizontal-bar mother" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "family-dot" }, null, -1))
const _hoisted_6 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4,
  _hoisted_5
]

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'FamilyConnector',
  props: {
    dimmed: { type: Boolean },
    layout: {},
    spacer: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;



const layoutRef = computed(() => props.layout || 'full')


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["family-connector", { ['connector-' + layoutRef.value]: true, spacer: props.spacer }]),
    dimmed: props.dimmed
  }, _hoisted_6, 10, _hoisted_1))
}
}

})